
import { Component, Prop } from "vue-property-decorator";
import StandardLayout from "../../components/layout/standard-layout/StandardLayout.vue";
import { DeliveryOnRouteSortOrder, DeliveryOnRouteSummary, DriverPageView, DriverView, SortBy } from "../../../generated/contracts";
import Api from "../../../core/api/Api";
import constants from "../../../core/constants";
import RouteHistoryView from "./RouteHistoryView.vue";
import DeliveryRouteHistoryView from "./DeliveryRouteHistoryView.vue";

@Component
export default class DriverPage extends StandardLayout<DriverView> {
    private deliveriesOnRoute: DeliveryOnRouteSummary[] = [];

    @Prop() private id!: string;

    protected async created() {
        this.pageView = await Api.driver.getDriverPage(this.id, DeliveryOnRouteSortOrder.Status, SortBy.Ascending,
            constants.NoOfRowsAtATime);

        // Remove statistics for now
        (this.pageView as any).statistics = null;

        this.deliveriesOnRoute = (this.pageView.content as DriverView).deliveriesOnRoute;
        this.sections = [
            {
                name: "Kørselshistorik",
                component: RouteHistoryView,
                props: {
                    id: this.id,
                    tab: "0"
                }
            },
            {
                name: "Leveringsruter",
                component: DeliveryRouteHistoryView,
                props: {
                    id: this.id,
                    tab: "1"
                }
            }
        ];

        if (this.pageView.content.currentDeliveryRouteId) {
            this.inTransit = {
                routeId: this.pageView.content.currentDeliveryRouteId,
                displayText: `Er aktiv på ruten`,
                simulated: false
            };
        }
        this.contactType = "phone";
    }
}
